import { useAxiosPrivate } from "./axios";

const fileDownload = require("js-file-download");

const LIST_QUERY = "/servicehistory/list";
const DETAIL_QUERY = "/servicehistory/get";
const DOWNLOAD_IMAGE = "/servicehistory/imagedownload";

export const useSearchHistory = () => {
  const searchHistory = async (params, callback) => {
    const searchParam = {
      offset: params.offset,
      limit: params.limit,
      clientName: params.clientName,
      machineNumber: params.machineNumber,
      serviceWorksheetNo: params.serviceWorksheetNo,
      salesOrderNo: params.salesOrderNo,
      date: params.date,
    };

    try {
      const controller = new AbortController();
      const response = await axiosPrivate.get(LIST_QUERY, {
        params: searchParam,
        signal: controller.signal,
      });
      callback(response.data);
    } catch (err) {
      callback(err);
    }
  };

  const axiosPrivate = useAxiosPrivate();
  return searchHistory;
};

export const useDetailHistory = () => {
  const loadDetailById = async (id, callback) => {
    try {
      const controller = new AbortController();
      const response = await axiosPrivate.get(DETAIL_QUERY, {
        params: {
          swId: id,
        },
        signal: controller.signal,
      });
      callback(response.data);
    } catch (err) {
      callback(err);
    }
  };

  const axiosPrivate = useAxiosPrivate();
  return loadDetailById;
};

export const useDownloadImage = () => {
  const downloadImage = async (path, name, callback) => {
    const searchParam = {
      path: path,
    };
    try {
      const controller = new AbortController();
      const response = await axiosPrivate.get(DOWNLOAD_IMAGE, {
        params: searchParam,
        signal: controller.signal,
        responseType: "arraybuffer",
      });
      fileDownload(response.data, name);
      callback(true);
    } catch (err) {
      callback(err);
    }
  };

  const axiosPrivate = useAxiosPrivate();
  return downloadImage;
};
